/**
 * @generated SignedSource<<6b5fd4c21fbf20f0897e04719b2b144a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type approvalDescription_softwareReleasesApprovers$data = {
  readonly description: string | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "approvalDescription_softwareReleasesApprovers";
};
export type approvalDescription_softwareReleasesApprovers$key = {
  readonly " $data"?: approvalDescription_softwareReleasesApprovers$data;
  readonly " $fragmentSpreads": FragmentRefs<"approvalDescription_softwareReleasesApprovers">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "approvalDescription_softwareReleasesApprovers",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    }
  ],
  "type": "JiraVersionApprover"
};

(node as any).hash = "c421fe945502a3b4d88465ed8f62bb82";

export default node;
